import React from 'react'

import useStyles from './styles'

const Header = ({ Icon = undefined, children }) => {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      {Icon && <Icon className={classes.icon} />}
      {children}
    </div>
  )
}

export default React.memo(Header)
